export function getTimezone() {
    //fallback = "America/Los_Angeles"
    let tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!(tz == undefined)) { return tz; } else {
        return new Date().getTimezoneOffset();
    }
}

export function time2string() {

}

export function getTimeString(timestamp, tz) {
    if (typeof tz === "string") {
        return new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', hour:'numeric', minute:'numeric', hour12:true,  timeZone: tz }).format(timestamp*1000) //.replace(",","",1);
    } else {
        return new Date(timestamp * 1000 - tz * 60000).toLocaleString();
    }
}